import { render, staticRenderFns } from "./CytomineNavbar.vue?vue&type=template&id=2b4f5f7e"
import script from "./CytomineNavbar.vue?vue&type=script&lang=js"
export * from "./CytomineNavbar.vue?vue&type=script&lang=js"
import style0 from "./CytomineNavbar.vue?vue&type=style&index=0&id=2b4f5f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports